module.exports = __webpack_public_path__ + "static/media/client-img2.503ad08f.jpg";